import { render, staticRenderFns } from "./OrganizationEmailTable.vue?vue&type=template&id=b54e6722&"
import script from "./OrganizationEmailTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationEmailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports